"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "furnari": {
    "846f4f89": [{
      "hkey": "8237c1bf",
      "slug": "tonnarella-portorosa",
      "name": "Tonnarella-Portorosa",
      "primary": true,
      "skipSearch": false
    }],
    "tonnarella": [{
      "hkey": "8237c1bf",
      "slug": "tonnarella-portorosa",
      "name": "Tonnarella-Portorosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;